export default __webpack_public_path__ + "static/media/asktheexpertmenuicon.4ce36584.svg";